import { apiRequest } from './apiService';

// Sales Services
export const fetchSalesServices = async () => {
  return await apiRequest('/sales/sales-services', 'GET');
};

export const createSalesService = async (serviceData: any) => {
  return await apiRequest('/sales/sales-services', 'POST', serviceData);
};
export const fetchSalesServiceById = async (id: any) => {
  return await apiRequest(`/sales/sales-services/${id}`, 'GET');
};
export const updateSalesService = async (id: string, data: any) => {
  return await apiRequest(`/sales/sales-services/${id}`, 'PUT', data);
};
export const deleteSalesService = async (id: string) => {
  return await apiRequest(`/sales/sales-services/${id}`, 'DELETE');
};
